<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-position="left"
    label-width="180px"
  >
    <el-form-item
      v-if=" !isAhGzElectronicBank"
      label="保函形式"
      prop="web_type"
    >
      <el-radio-group v-model="form.web_type" @change="elRadioGroup">
        <el-radio label="electron">电子-银行投标保函</el-radio>
        <el-radio label="paper" v-if="!isHlj">纸质-银行投标保函</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="投标人名称" prop="bidderCompanyName">
      <el-input
        v-model="form.bidderCompanyName"
        placeholder="请填写投标人名称"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="isAhGzElectronicBank"
      label="统一社会信用代码"
      prop="bidderSocialCreditCode"
    >
      <el-input
        v-model="form.bidderSocialCreditCode"
        placeholder="请填写统一社会信用代码"
      />
      <el-button type="text">
        <span @click="to('https://www.cods.org.cn/')">点此查询统一社会信用代码</span>
      </el-button>
    </el-form-item>
    <el-form-item label="企业办公地址" prop="bidderLinkAdress">
      <el-input
        v-model="form.bidderLinkAdress"
        placeholder="请填写企业办公详细地址用于快递或票务"
      />
    </el-form-item>
    <el-form-item v-if="isAhGzElectronicBank" label="法人姓名" prop="orgLegalPerson">
      <el-input
        v-model="form.orgLegalPerson"
        placeholder="请填写企业法人姓名"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="isAhGzElectronicBank"
      label="法人身份证号码"
      prop="certificatesNo"
    >
      <el-input
        v-model="form.certificatesNo"
        placeholder="请填写法人身份证号码"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="isAhGzElectronicBank"
      label="法人身份证到期日"
      prop="certificatesEndDate"
    >
    <el-date-picker
            placeholder="请选择身份证到期日"
            v-model="form.certificatesEndDate"
            type="date"
            :disabled="isCertificatesEndDate"
            :picker-options="{
              disabledDate: disabledDate,
            }"
          />
    <el-checkbox @change="certificatesEndDateBoxChange" class="certificatesEndDateBox" v-model="form.certificatesEndDateBox">
      长期有效
    </el-checkbox>
    </el-form-item>
    <el-form-item
      label="法人身份证扫描件"
      prop="deputyMaterialFileId"
      ref="isFile"
      v-if="isAhGzElectronicBank"
    >
      <FileUpload :id.sync="form.deputyMaterialFileId" ref="FileUpload" accept=".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg">
        <div>
          <span>请上传法人身份证 （含正反面扫描件），支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</span>
        </div>
      </FileUpload>
    </el-form-item>
    <el-form-item label="联系人" prop="bidderLinkName">
      <el-input
        v-model="form.bidderLinkName"
        placeholder="请填写联系人姓名"
      ></el-input>
    </el-form-item>
    <el-form-item label="联系方式" prop="bidderMobilePhone">
      <el-input
        v-model="form.bidderMobilePhone"
        placeholder="请填写联系人联系方式"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="营业执照"
      prop="businessLicense"
      ref="isFile"
    >
      <FileUpload :id.sync="form.businessLicense" ref="FileUpload" accept=".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg">
        <div>
          <span>请上传营业执照副本扫描件，支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</span>
        </div>
      </FileUpload>
    </el-form-item>

    <el-form-item>
      <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
      <el-button type="primary" @click="onSubmit">下一步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import FileUpload from './components/fileUpload'
import { bidderMobilePhonePass, identityCardPass } from '@/shared/validate'
import { to } from '@/shared/location'
import store from './mixins/store'
import { cloneDeep } from 'lodash'
import { queryOrderByOuterOrderNo,queryOrderDetail } from '@/api/order'
import { getUserRes} from '@/api/user'
import dayjs from 'dayjs'
import { ORDER_TYPE, checkGuaranteeDraft, saveCurrentDraft } from '@/shared/guaranteeDraft'
export default {
  name: 'Step1',
  components: {
    FileUpload: FileUpload,
  },
  mixins: [store],
  watch: {
    'form.businessLicense': function(newVal, oldVal) {
      if (newVal) {
        if (this.$refs.isFile) this.$refs.isFile.clearValidate()
      }
    },
  },
  data() {
    const validFile = function(k, _, v, cb) {
      if (this.form[k]) {
        cb()
      } else {
        cb(new Error('请上传文件'))
      }
    }
    return {
      to: to,
      draftSaving: false,
      form: {
        web_type: this.$route.query.web_type || 'electron',
      },
      rules: {
        web_type: {
          required: true,
          message: '请选择保函形式',
          trigger: 'change',
        },
        bidderCompanyName: { required: true, message: '请填写投标人名称' },
        bidderLinkName: {
          required: true,
          message: '请填写联系人姓名',
        },
        orgLegalPerson: {
          required: true,
          message: '请填写企业法人姓名',
        },
        certificatesNo: {
          required: true,
          validator: identityCardPass,
          trigger: 'blur',
        },
        certificatesEndDate: {
          required: true,
          message: '请选择法人身份证到期日',
          trigger: 'change',
        },
        bidderSocialCreditCode: {
          required: true,
          message: '请填写统一社会信用代码',
        },
        bidderLinkAdress: {
          required: true,
          message: '请填写企业办公地址',
        },
        bidderMobilePhone: {
          required: true,
          validator: bidderMobilePhonePass,
          trigger: 'blur',
          // message: '请输入手机号',
        },
        businessLicense: {
          required: true,
          validator: validFile.bind(this, 'businessLicense'),
        },
        openingPermit: {
          required: true,
          validator: validFile.bind(this, 'openingPermit'),
        },
        deputyMaterialFileId: {
          required: true,
          validator: validFile.bind(this, 'deputyMaterialFileId'),
        },
        attr1: { required: true, validator: validFile.bind(this, 'attr1') },
        attr2: { required: true, validator: validFile.bind(this, 'attr2') },
        attr3: { required: true, validator: validFile.bind(this, 'attr3') },
        expressNum: { required: true, message: '请填写快递单号' },
      },
    }
  },
  computed: {
    //电子银行保函
    isElectron() {
      if(this.isAhGzElectronicBank){
        this.$set(this.form, 'web_type', 'electron')
      }
      return this.form.web_type === 'electron'
    },
    //纸质银行保函
    isPaper() {
      return this.form.web_type === 'paper'
    },
    //判断是否为电子银行保函
    isAhGzElectronicBank() {
      return this.$route.path.includes('anhui') || this.$route.path.includes('guizhouBank')
    },
    isCertificatesEndDate(){
      return this.form.certificatesEndDate === 253402185600000
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    }
  },
  created() {
    this.initWithDraftCheck()
  },
  beforeMount() {},
  methods: {
    /**
     * 带草稿检查的初始化：新订单场景下若存在 Redis 草稿则弹窗让用户选择
     */
    async initWithDraftCheck() {
      const q = this.$route.query
      const isNewOrder = !q.orderID && !q.orderId
      // fromStep2: URL 带 step2Id=step2（同流程内 step2→step1 导航标记）
      // vuexHasData: Vuex guarantee 是否有数据（同流程内 step1→step2 的 onSubmit 已写入）
      // 双条件都满足才跳过 Redis 检查：刷新后 Vuex 空了 → 即使 step2Id 还在 URL 上也必须查 Redis
      const fromStep2 = q.step2Id === 'step2'
      const vuexHasData = Object.keys(this.state || {}).length > 0
      if (isNewOrder && !(fromStep2 && vuexHasData)) {
        const shown = await checkGuaranteeDraft(this, ORDER_TYPE.BANK_8000, {
          restore: (draft) => {
            if (draft.formData) {
              this.form = { ...this.form, ...draft.formData }
              // 如果保存时已到 step2，直接跳过去
              if (draft.step === 'step2') {
                this.guarantee(this.form)
                const pFast = this.$route.path.split('/bank')[0]
                this.$router.replace({
                  path: `${pFast}/bank/step2`,
                  query: this.$route.query,
                })
                return
              }
            }
          },
          skipRestore: () => {
            // 重新申请 —— 清 Vuex 后走原有 init()（localStorage 已废弃，不再需要额外清理）
            this.clear()
            this.init()
          },
        })
        if (shown) return
      }
      // 非新订单场景 / 同流程内导航(step2→step1) / 无草稿 —— 走原有初始化
      this.init()
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        await saveCurrentDraft(this, ORDER_TYPE.BANK_8000, 'step1', this.form)
      } finally {
        this.draftSaving = false
      }
    },
    init() {
      const { outerOrderNo, step2Id, orderID,reapply } = this.$route.query
      this.form.reapply = reapply
      const triggerAutoFill = () => {
        const isNewOrderScene = !orderID && !this.$route.query.outerOrderNo
        if (!isNewOrderScene) return
        if(!this.isZCMOrigin){
          if(this.isAhGzElectronicBank){
            const ptName = this.$route.path.includes('anhui')?'安徽移动':'贵州银行'
            this.$confirm('此为'+ptName+'平台专属申请页面，请确认您的项目是否为'+ptName+'项目 ，若是，请点击"确定"继续申请保函，若否，请您点击页面顶部"保函申请" 选择正确的保函类型进行申请', '提示', {
              confirmButtonText: '确定',
              type: 'info',
              showCancelButton:false
            }).then(() => {
              this.$confirm('是否自动填入资料库中企业信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
              }).then(() => {
                this.getUserInfo()
              })
            })
          } else {
            this.$confirm('是否自动填入资料库中企业信息?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'info'
            }).then(() => {
              this.getUserInfo()
            })
          }
        }
      }
      if (orderID) {
        this.getDataDetail(orderID).then((data) => {
        if(data){
             this.form = { ...this.form, ...data}
             //安徽移动默认电子银行保函
             if((data.apiId && (data.apiId == 'ahyh' || data.apiId == 'gzyh' || this.isHlj ))|| data.isExectronic === '1'){
                  this.$set(this.form, 'web_type', 'electron')
             }
             this.form.certificatesEndDateBox = this.form.certificatesEndDate != 253402185600000?false:true
        }
          triggerAutoFill()
      })
      } else if (outerOrderNo) {
        // 从重庆水务点击【申请投标保函】跳转到当前页面
        // 同流程内 step2→step1 且 Vuex 仍有数据时才走内存态恢复
        // 刷新后 Vuex 空了 → 跳过此分支，走 queryOrderByOuterOrderNo 从后端恢复
        const vuexHasData = Object.keys(this.state || {}).length > 0
        if (step2Id === 'step2' && vuexHasData) {
          this.form = { ...this.form, ...this.state }
          return
        }
        queryOrderByOuterOrderNo(outerOrderNo).then((v) => {
          if (v.data) {
            //除安徽移动、贵州银行外默认纸质保函
            if(this.isAhGzElectronicBank){
              this.$set(this.form, 'web_type', 'electron')
            }
            if (v.data.model) {
              this.form = { ...this.form, ...v.data.model }
            }
          }
          triggerAutoFill()
        })
      } else if (step2Id === 'step2' && Object.keys(this.state || {}).length > 0) {
        // step2 点上一步跳回 step1，Vuex 内存态恢复（纯新订单，无 outerOrderNo）
        // 刷新后 Vuex 空了 → 跳过此分支，走 triggerAutoFill
        this.form = { ...this.form, ...this.state }
      } else {
        triggerAutoFill()
      }

    },
    getDataDetail(orderID) {
      return queryOrderDetail(orderID).then((v) => {
        return v.data
      })
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(this.form)
          this.form.isExectronic = this.form.web_type === 'paper' ? '0' : '1'
          this.guarantee(this.form)

          // 构造干净的 query：清 step2Id、打 step1Id 标记 —— 不直接修改 this.$route.query
          const { step2Id: _s2, step1Id: _s1Old, ...restQ } = this.$route.query
          const newQ = { ...restQ, step1Id: 'step1' }
          const pFast = this.$route.path.split('/bank')[0]
          this.$router.push({
            path: `${pFast || '/anhui' || '/guizhouBank'}/bank/step2`,
            query: newQ,
          })
        }
      })
    },
    elRadioGroup() {
      this.$refs.form.clearValidate()
    },
    getUserInfo() {
      getUserRes().then((v) => {
        if (typeof v.data === 'object') {
           this.$set(this.form, 'bidderCompanyName', v.data.companyName)
           this.$set(this.form, 'bidderSocialCreditCode', v.data.unifySocietyCreditCode)
           this.$set(this.form, 'orgAddress', v.data.registeredAddress)
           //this.$set(this.form, 'orgTel', v.data.companyName)
           this.$set(this.form, 'orgLegalPerson', v.data.legalPerson)
           this.$set(this.form, 'bidderLinkName', v.data.linkMan)
           this.$set(this.form, 'bidderMobilePhone', v.data.linkManPhone)
           this.$set(this.form, 'businessLicense', v.data.businessLicense)
           this.$set(this.form, 'certificatesEndDate', v.data.certificatesEndDate)
           this.form.certificatesEndDateBox = v.data.certificatesEndDate != 253402185600000?false:true
        }
      })
    },
    disabledDate(cur) {
      return dayjs().isAfter(dayjs(cur).add(1, 'days'))
    },
    certificatesEndDateBoxChange(val){
      if(val){
        this.form.certificatesEndDate = 253402185600000
      }else{
        this.form.certificatesEndDate = ''
      }
    }
  },
  mounted(){
    // 自动填充弹窗已迁移到 init() 末尾，由缓存检查之后统一触发
  },
}
</script>

<style lang="scss" scoped>
.mailing {
  color: #bb2b2b;
  margin-bottom: 20px;
  &-cube {
    div {
      display: inline-block;
      margin-right: 20px;
    }
  }
}
.certificatesEndDateBox{
  margin-left: 20px;
}
</style>
